import loadable from '@loadable/component';

export const Vimeo = loadable(() => import('./VimeoBase'));
